<p-sidebar [(visible)]="visibleUserFilter"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'640px'}">
    <ng-template pTemplate="header">
        <div class="user-filter-header">
            Filter
        </div>
    </ng-template>
    <div>
        <p-toast></p-toast>

        <p-scrollPanel [style]="{height: 'calc(100vh - 190px)'}">
            <div class="user-filter-title">
                Sign up period
            </div>
            <div class="flex flex-row">
                <div class="w-15rem">
                    <label for="dateformat" class="user-filter-label">Start date</label>
                    <p-calendar [(ngModel)]="filterObj.startDateJoin" dateFormat="mm-dd-yy"
                                inputId="dateformat"
                                placeholder="Select Start Date"></p-calendar>
                </div>
                <div>
                    <hr class="user-filter-hyphen" />
                </div>
                <div class="w-15rem">
                    <label for="dateformat" class="user-filter-label">End date</label>
                    <p-calendar [(ngModel)]="filterObj.endDateJoin" dateFormat="mm-dd-yy"
                                inputId="dateformat"
                                placeholder="Select End Date"></p-calendar>
                </div>
            </div>

            <div class="user-filter-title">
                Total Spend
            </div>
            <div class="flex flex-row">
                <span class="user-filter-total-spend" 
                      [class]="(!filterObj.digitType) ? 'user-filter-total-spend__active' : ''" (click)="selectDigit(digitType.None)">All</span>
                <span class="user-filter-total-spend"
                      [class]="(filterObj.digitType === digitType.OneDigit) ? 'user-filter-total-spend__active' : ''"
                       (click)="selectDigit(digitType.OneDigit)">₱</span>
                <span class="user-filter-total-spend"
                      [class]="(filterObj.digitType === digitType.TwoDigits) ? 'user-filter-total-spend__active' : ''"
                       (click)="selectDigit(digitType.TwoDigits)">₱₱</span>
                <span class="user-filter-total-spend"
                      [class]="(filterObj.digitType === digitType.ThreeDigits) ? 'user-filter-total-spend__active' : ''"
                       (click)="selectDigit(digitType.ThreeDigits)">₱₱₱</span>
                <span class="user-filter-total-spend"
                      [class]="(filterObj.digitType === digitType.FourDigits) ? 'user-filter-total-spend__active' : ''"
                       (click)="selectDigit(digitType.FourDigits)">₱₱₱₱</span>
            </div>
        </p-scrollPanel>

        <hr class="hr-filter" />

        <div class="flex justify-content-end mrg-10-0px">
            <button class="outlined-white-btn" pButton label="Clear" (click)="clear()"></button>
            <button class="btn-darkblue ml-3" pButton label="Apply" (click)="clickFilter()"></button>
        </div>
    </div>
</p-sidebar>
